import "../../stylesheets/old-adapter.scss"

import "../common/components/button"
import "../common/components/flash"
import "../common/components/tabbed-content"
import "../common/components/search"
import "../common/components/header"
// import "../common/components/cookie-bar"
import "../common/components/map-new"
import "../common/components/global-notice"
